import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit, Smartphone, ShieldCheck, CheckCircle2, Code2, MapPinned, Megaphone, Server, Activity } from 'lucide-react';
const services = [{
  id: 'ai',
  title: 'AI & Machine Learning',
  description: 'Leverage artificial intelligence to automate processes, gain predictive insights, and build smarter products.',
  icon: BrainCircuit,
  features: ['Predictive Analytics & Forecasting', 'Natural Language Processing (NLP)', 'Computer Vision Solutions', 'Custom LLM Integration']
}, {
  id: 'mobile',
  title: 'Mobile App Development',
  description: 'Create engaging, high-performance native and cross-platform mobile experiences that your users will love.',
  icon: Smartphone,
  features: ['iOS & Android Native Apps', 'React Native & Flutter', 'UI/UX Design & Prototyping', 'App Store Optimization']
}, {
  id: 'frontend',
  title: 'Frontend Development',
  description: 'Build fast, responsive, and pixel-perfect web interfaces using modern frameworks and best practices.',
  icon: Code2,
  features: ['React & TypeScript Applications', 'Responsive & Accessible Design', 'Performance Optimization', 'Design System Implementation']
}, {
  id: 'backend',
  title: 'Backend & System Design',
  description: 'Architect and build scalable backend systems that handle millions of requests with reliability and efficiency.',
  icon: Server,
  features: ['Building Scalable Services', 'APIs & Distributed Systems', 'High Traffic System Architecture', 'Database Design & Optimization']
}, {
  id: 'production',
  title: 'Production-Level Engineering',
  description: 'Ship real-world systems used by millions with a focus on reliability, performance, and operational excellence.',
  icon: Activity,
  features: ['Systems Serving Millions of Users', 'Reliability & Uptime Engineering', 'Performance Monitoring & Tuning', 'CI/CD & DevOps Best Practices']
}];
export function Services() {
  return <section id="services" className="py-24 bg-white" data-id="element-165">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-166">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-167">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-bold text-primary mb-4" data-id="element-168">
            Our Core Expertise
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-slate-600" data-id="element-169">
            From AI and mobile apps to backend architecture and production
            engineering — we deliver end-to-end technology solutions that drive
            growth.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-170">
          {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 group" data-id="element-171">
              <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-172">
                <service.icon className="w-7 h-7 text-accent" data-id="element-173" />
              </div>

              <h3 className="text-xl font-bold text-primary mb-3" data-id="element-174">
                {service.title}
              </h3>
              <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-175">
                {service.description}
              </p>

              <ul className="space-y-3" data-id="element-176">
                {service.features.map((feature, fIndex) => <li key={fIndex} className="flex items-start gap-3" data-id="element-177">
                    <CheckCircle2 className="w-5 h-5 text-accent shrink-0 mt-0.5" data-id="element-178" />
                    <span className="text-sm text-slate-700 font-medium" data-id="element-179">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}